import type { FaireThemeEntity } from "../../entity_types/theme";

export const mystic_and_meaningful_tokens: FaireThemeEntity = {
  token: "mystic-and-meaningful-tokens",
  type: "theme",
  name: "Mystic & Meaningful Tokens",
  description: "Jewelry with tarot symbols, angel numbers, and protective evil eyes -- spiritual connection that pairs with a restorative beauty lounge vibe.",
  teaser: "Spiritual jewelry that matches your lounge's restorative energy.",
  detail: "San Jose's metaphysical and spiritual aesthetics are high-performing. Your engagement with Gifts from the Crypt and Evileyefavor shows interest in symbolic jewelry -- Good Fortune Tarot Card Necklace, Angel Numbers Necklace, Gold Evil Eye Bracelet Set.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_x8zn8z9mdw",
    "p_5lazl70x",
    "p_ps3ufaemx5",
    "p_9ebda6svmo",
    "p_xpyyzvehfy",
    "p_6rm9cthdfr",
    "p_juex45tn7n",
    "p_vwssret42y",
    "p_egnnzqszi6",
    "p_kk9u5fmpf9",
    "p_bryjg59c5k",
    "p_mxau2n7tg4",
    "p_u3fcq7r777",
    "p_74jb4dfpzt",
    "p_ze2mdxspej",
    "p_kjwfdfzbjt",
    "p_abkkzv5z3b",
    "p_ju2puhctrf",
    "p_vkva66tczr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
